<template>
  <div class="m-10">
    <button v-if="!externalNavigation"
        @click="showHowTo = true"
        class="bg-indigo-600 hover:bg-indigo-700 text-white font-medium px-6 py-3 rounded-lg shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-150 border border-indigo-500 hover:border-indigo-400"
      >
        How-To Agent
      </button>

    <HowToGuide
      v-if="isGuideVisible"
      :pages="agentConfigGuidePages"
      :initial-page="0"
      @close="handleClose"
      @complete="handleGuideComplete"
      @page-change="handlePageChange"
    />
  </div>
</template>

<script>
import { ref, computed } from "vue";
import HowToGuide from "@/components/HowToGuide.vue";

import agentImage from "@/assets/howto/agent/agent.png";
import agentAddImage from "@/assets/howto/agent/agent-add.png";
import agentCompleteImage from "@/assets/howto/agent/agent-complete.png";
import agentConfigImage from "@/assets/howto/agent/agent-config.png";
import agentCreationImage from "@/assets/howto/agent/agent-creation.png";
import agentDisplayImage from "@/assets/howto/agent/agent-display.png";
import agentLicensKeyImage from "@/assets/howto/agent/agent-licenskey.png";
import agentTypeImage from "@/assets/howto/agent/agent-type.png";


export default {
  name: "ParentComponent",
  components: {
    HowToGuide,
  },
  
  props: {
    showHowToPage: {
      type: Boolean,
    },
    externalNavigation: {
      type: Boolean,
    }
  },

  emits: ["showHowToClose"],
  setup(props, { emit }) {
    const showHowTo = ref(false);

    const isGuideVisible = computed(() => {
      return props.externalNavigation ? props.showHowToPage : showHowTo.value;
    }); 

    const agentConfigGuidePages = ref([
    {
        heading: "Navigate to Agent",
        upperText: [
            "From the main navigation menu, click on \"Workspace\".",
            "Select \"Agents\" from the submenu.",
            "You'll see the Agent Overview page showing all existing Agents. 'If any exist'. Before creating a new Agent, review the existing Agents."
        ],
        image: agentImage,
        imageAlt: "Agent navigation screenshot",
        lowerText: []
    },
    {
        heading: "Initiate Agent Creation",
        upperText: [
            "Click the \"Add Agent\" button.",
            "This will open the \"Agent Configuration form\".",
        ],
        image: agentAddImage,
        imageAlt: "Agent creation form screenshot",
        lowerText: []
    },
    {
        heading: "Initiate Agent Creation",
        upperText: [],
        image: agentConfigImage,
        imageAlt: "Agent creation form screenshot",
        lowerText: [
            "Click the \"Select an organisation\" dropdown: This determines which organisation will be applied.", 
            "Click the \"Select an operating system\" dropdown: This determines which operating system setting will be applied.",
            "Click the \"Submit\" button.",
            "This will open the \"Agent configuration type\" form."
        ]
    },
    {
        heading: "Agent Configuration Type",
        upperText: [
            "Click the \"Select a config type\" dropdown.",
            "Choose the \"config type\" from the list.",
            "A progress bar will appear showing the remaining steps required to fully confgure an agent."
        ],
        image: agentTypeImage,
        imageAlt: "Agent configuration type form",
        lowerText: [
            "Click the \"Next\" button (blue button, bottom right corner).",
            "This will complete the \"Agent creation\"."
        ]
    },
    {
        heading: "Completion",
        upperText: [
          "When the MivuInstaller Agent generation is complete, the view below will be displayed to confirm completion."
        ],
        image: agentCompleteImage,
        imageAlt: "Agent configuration type form",
        lowerText: []
    }
]);

    const handleGuideComplete = () => {
      showHowTo.value = false;
      emit("showHowToClose", false);
    };

    const handlePageChange = (pageIndex) => {
      console.log(`User navigated to page ${pageIndex + 1}`);
    };

    const handleClose = () => {
      if (props.externalNavigation){
        emit("showHowToClose", false);
      } else {
        showHowTo.value = false;
      }
    }

    return {
      showHowTo,
      agentConfigGuidePages,
      handleGuideComplete,
      handlePageChange,
      handleClose,
      isGuideVisible
    };
  }
};
</script>